import * as z from "zod/v4";

export const updateShipmentViewFolder = {
  name: "updateShipmentViewFolder" as const,
  input: z.object({ folderId: z.string(), name: z.string() }),
  output: z.object({}),
};
